import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.generated.css';
import './index.css';
import { purgeLegacyAuthStorage } from './config/api-config';
import { ConfigProvider } from './context/ConfigContext';
import { AuthProvider } from './context/AuthContext';
import App from './App';

purgeLegacyAuthStorage();

// Pages mount only after config/auth resolve, so the document is still just the
// loading spinner while the browser decides where to restore scroll to. It then
// applies the remembered offset once the real (much taller) page renders, which
// lands the visitor mid-page. Opt out before the first render.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
